<template>


  <v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>

      <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Welcome to Insider
        </v-card-title>

        <v-card-text>
          Please add a name and biography to your profile so that your contacts can search and connect with you easier. 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
            to='/editprofile'
          >
            Edit Profile
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

      <v-toolbar>
    <v-toolbar-title>{{ user.name }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">

      <v-menu offset-y>
      <v-btn
        flat
        slot="activator"
        color="primary"
        dark
        v-show='isCurrentUser' 
        @click="messagesShowing = !messagesShowing"
      >
      <v-badge right>
        <span slot="badge" v-if="notifications.filter((notification) => !notification.read).length > 0">{{notifications.filter((notification) => !notification.read).length}}</span>
        <v-icon large>message</v-icon>
      </v-badge>
      </v-btn>
      <v-messages ref="messages" v-bind:notifications="notifications"></v-messages>
    </v-menu>

      <v-menu offset-y>
      <v-btn
        slot="activator"
        color="secondary"
        dark
        @click='toggleShowContacts' flat
      >
        <v-icon large>people</v-icon>
      </v-btn>
      <v-list v-show="contacts.length > 0" >
        <v-list-tile
          v-for="(contact, index) in contacts"
          :key="index"
          @click="$router.push('/profile/'+contact.contactID)"
        >
          <v-list-tile-title>{{ contact.contactName }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile>
          <!-- <v-search></v-search> -->
        </v-list-tile>
      </v-list>
       <v-dialog v-model="showSearch">
            <v-btn slot="activator">
            Find New Contacts 
            <v-icon right>search</v-icon>
          </v-btn>
          <v-search></v-search>
          </v-dialog>
    </v-menu>


      <v-menu offset-y>
      <v-btn
        flat
        slot="activator"
        color="primary"
        dark
        v-show='isCurrentUser' 
      >
        <v-icon large>settings</v-icon>
      </v-btn>
      <v-list>

        <v-list-tile to='/editprofile'>
          <v-list-tile-title>Edit Profile</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    </v-toolbar-items>
  </v-toolbar>


      <v-card>
        <br>
        <v-card-text>
          <div class="text-md-center">
            <v-avatar size = 140>
              <img :src= user.photoURL alt="avatar">
            </v-avatar>
            <br><br>
            <!-- <h3>{{ user.name }}</h3> -->
          </div>
          <br>
          <hr>
          <br>
          <div class="text-md-center">
            <p v-if="user.title != null"> Job Title: {{ user.title }}</p>
            <p v-if="user.organization != null"> Organization: {{user.organization}}</p>
            <br>
          <hr>
          <br>
          <h2> About Me </h2>
          <br>
            <p>{{ user.bio}}</p>
            
            <hr>
            <v-dialog v-model="inviteDiag" width="500">
<v-btn slot="activator" class="primary" round> Invite Friends</v-btn>
<v-card class="white" height="300" width="500">
  <v-card-title class="primary"><h1>Invite Friends</h1></v-card-title>
  <br>
  <v-text-field
            name="email"
            label="Email"
            id="email"
            v-model="emails"
            type="text"
            required
            class="primary"
            style="margin: 5px"
            :rules="emailRules"></v-text-field>
            <br>
            
<v-btn class="secondary" round @click="invite()"> Invite </v-btn>
<v-btn class="secondary" round @click="close()"> Cancel </v-btn>
</v-card>

</v-dialog>
          </div>
          
        </v-card-text>
     </v-card>

    <br>

     <div class="text-md-center">
      <v-btn v-show='!isCurrentUser && !isContact' round color="secondary" @click='connect'>Connect With {{user.name}}</v-btn>
      <v-btn v-show='isPending' round disabled> You have requested to connect with {{user.name}} </v-btn>
      <v-btn v-show='isContact && !isPending' round disabled> You are connected with {{user.name}} </v-btn>
     </div>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import firebase from '../../Firebase/FirebaseInit'
import vMessages from './Messages.vue'
import vSearch from '../Contacts/Search.vue'
// import Vue from 'vue'
export default {
  data () {
    return {
      user: {},
      isContact: false,
      isPending: false,
      emails: '',
      contacts: [],
      showContacts: false,
      showSearch: false,
      messagesShowing: false,
      dialog: false,
      notifications: [],
      inviteDiag: false,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
      ],
      emailValid: false
    }
  },
  components: {
    vMessages,
    vSearch
  },
  computed: {
    isCurrentUser () {
      return this.$store.getters.user.id === this.$route.params.id
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'reset',
    messagesShowing: 'readMessages'
  },
  validations: {
    emails: {email: this.emailRules}
  },
  methods: {
    readMessages () {
      if (!this.messagesShowing) {
        this.$refs.messages.readMessages()
      }
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.emailValid = re.test(email)
    },
    invite () {
      if (this.emails !== null && this.emails !== '') {
        this.validateEmail(this.emails)
        if (this.emailValid) {
          this.inviteDiag = false
          alert('Form submitted')
          // send email
          this.emails = ''
        }
      }
    },
    close () {
      this.inviteDiag = false
      this.emails = ''
    },
    reset () {
      this.user = {}
      this.isContact = false
      this.isPending = false
      this.contacts = []
      this.showContacts = false
      this.showSearch = false
      this.emails = ''
      this.emailValid = false
      this.messagesShowing = false
      this.dialog = false
      this.inviteDiag = false
      this.notifications = []
      this.pullFromDatabase()
    },
    connect () {
      let timestamp = new Date().getTime()
      const notification = {
        message: this.$store.getters.user.name + ' would like to connect with you!',
        senderID: this.$store.getters.user.id,
        senderName: this.$store.getters.user.name,
        receiverID: this.user.id,
        receiverName: this.user.name,
        read: false,
        accepted: null,
        type: 'ContactRequest',
        timestamp
      }
      const contact = {
        contactID: this.user.id,
        contactName: this.user.name,
        accepted: false,
        timestamp
      }
      this.$store.dispatch('sendNotification', notification)
      this.$store.dispatch('addContact', {payload: contact, userID: this.$store.getters.user.id})
      this.isContact = true
      this.isPending = true
    },
    toggleShowContacts () {
      this.showContacts = !this.showContacts
    },
    pullFromDatabase () {
      firebase.firestore()
      .collection('users')
      .doc(this.$route.params.id)
      .get().then((doc) => {
        let user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'title': doc.data().title,
          'organization': doc.data().organization
        }
        this.user = user
        this.dialog = ((this.user.name == null || this.user.bio == null) && this.user.id === this.$store.getters.user.id)
      })
      .then(() => {
        firebase.firestore()
        .collection('users')
        .doc(this.user.id)
        .collection('contacts')
        .where('accepted', '==', true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.contacts.push(doc.data())
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
      })

      firebase.firestore()
      .collection('users')
      .doc(this.$store.getters.user.id)
      .collection('contacts')
      .where('contactID', '==', this.$route.params.id)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.size !== 0) {
          this.isContact = true
          this.isPending = !querySnapshot.docs[0].data().accepted
        }
      })
      .catch((error) => {
        console.log('Error getting documents: ', error)
      })

      firebase.firestore()
      .collection('users')
      .doc(this.$store.getters.user.id)
      .collection('notifications')
      // .where('read', '==', false)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
          let notification = doc.data()
          notification.id = doc.id
          this.notifications.push(notification)
        })
      })
      .catch((error) => {
        console.log('Error getting documents: ', error)
      })
    }
  },
  created () {
    this.pullFromDatabase()
  }
}
</script>




// WEBPACK FOOTER //
// Profile.vue?636db0d3